import { SVGProps } from "react"

export const ArrowIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="64" height="64" {...props}>
        <path
            d="M413.007808 511.902495l371.98248 371.982479a82.026281 82.026281 0 0 1-115.98248 115.98248L239.009712 569.99124a82.026281 82.026281 0 0 1 0-115.98248l429.998096-429.998095a82.026281 82.026281 0 0 1 115.98248 115.982479z"
            fill="currentColor"></path>
    </svg>
)
